<div class="d-flex flex-column passengers-preview">
  <div class="d-flex align-items-center justify-content-between">
    <h2 class="semi-bold">Travelers</h2>
    <div
      data-id="passengers-edit"
      (click)="editClick.emit()"
      class="cursor-pointer d-flex align-items-center text-travalign-main"
    >
      <img src="assets/icons/edit.svg" alt="edit" />
      <p class="ml-2 semi-bold">Edit</p>
    </div>
  </div>

  <ds-info-block>Traveler names must match government-issued photo ID exactly.</ds-info-block>

  <div class="d-flex flex-column passengers-preview-container">
    @for (passenger of passengers; track passenger; let index = $index, last = $last) {
      <div data-id="passenger">
        <p class="caption semi-bold pb-1">Traveler {{ index + 1 }}</p>

        <div [class.last]="last" class="d-flex passengers-preview-row pb-4">
          <div class="d-flex align-items-center text-ellipsis passengers-preview-row-left-part">
            <p data-id="passenger-name">
              {{ passenger.firstName }}
              @if (passenger.middleName) {
                {{ passenger.middleName }}
              }
            </p>
            &nbsp;
            <p data-id="passenger-last-name">{{ passenger.lastName }}</p>

            <div class="d-flex align-items-center justify-content-center dot-wrapper">
              <ds-dot-separator />
            </div>

            <p data-id="passenger-birthday">{{ passenger.birthday | date }}</p>

            <div class="d-flex align-items-center justify-content-center dot-wrapper">
              <ds-dot-separator />
            </div>

            <p data-id="passenger-gender">{{ passenger.gender | label }}</p>
          </div>

          @if (false) {
            <div class="d-flex align-items-center">
              <div class="passengers-preview-row-icon mr-2"></div>
              <p data-id="passenger-passport-id">{{ passenger.passportCountryId }}</p>
              <div class="d-flex align-items-center justify-content-center dot-wrapper">
                <ds-dot-separator />
              </div>
              <p data-id="passenger-passport-expiration-date">Expiration date:</p>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
